__turbopack_context__.v({
  "afterEnter": "BlockWhereToBuy-module-scss-module__WVhRna__afterEnter",
  "bodyCopy": "BlockWhereToBuy-module-scss-module__WVhRna__bodyCopy",
  "fade-in": "BlockWhereToBuy-module-scss-module__WVhRna__fade-in",
  "flushBottom": "BlockWhereToBuy-module-scss-module__WVhRna__flushBottom",
  "flushTop": "BlockWhereToBuy-module-scss-module__WVhRna__flushTop",
  "heading": "BlockWhereToBuy-module-scss-module__WVhRna__heading",
  "headline": "BlockWhereToBuy-module-scss-module__WVhRna__headline",
  "icon": "BlockWhereToBuy-module-scss-module__WVhRna__icon",
  "inner": "BlockWhereToBuy-module-scss-module__WVhRna__inner",
  "lastBlock": "BlockWhereToBuy-module-scss-module__WVhRna__lastBlock",
  "link": "BlockWhereToBuy-module-scss-module__WVhRna__link",
  "linkWrapper": "BlockWhereToBuy-module-scss-module__WVhRna__linkWrapper",
  "lockup": "BlockWhereToBuy-module-scss-module__WVhRna__lockup",
  "lockupInner": "BlockWhereToBuy-module-scss-module__WVhRna__lockupInner",
  "onEnter": "BlockWhereToBuy-module-scss-module__WVhRna__onEnter",
  "root": "BlockWhereToBuy-module-scss-module__WVhRna__root",
  "spin-icon": "BlockWhereToBuy-module-scss-module__WVhRna__spin-icon",
  "track": "BlockWhereToBuy-module-scss-module__WVhRna__track",
});
